<template>
    <vs-popup classContent="popup-example"  title="سفارش محصول" :active.sync="showPopup">
        <div class="mb-base">
            <form class="px-4" @keydown.enter.prevent.self>
                <vs-row class="px-5 pb-5">
                    <vs-col vs-lg="5" vs-md="5" vs-sm="12">
                        <label class="vs-input--label">انتخاب کاربر</label>
                        <v-select :options="usersList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="user_id" :clearable="false" />
                    </vs-col>
                    <vs-col vs-lg="5" vs-md="5" vs-sm="12">
                        <label class="vs-input--label input-left">نوع دسته بندی</label>
                        <v-select :options="categoryList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="category" class="input-left" :clearable="false" />
                    </vs-col>
                </vs-row>
                <div v-for="(item, index) in orders" :key="index" class="p-1 mt-4">
                    <span class="px-3">محصول شماره {{index+1}}</span>
                    <vs-button class="float-right btn-icon" color="danger" type="flat" @click="removeRow(index)" v-if="orders.length > 1">
                        حذف
                    </vs-button>
                    <vs-divider class="mb-5" />
                    <vs-row class="px-5 pb-5">
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label">عرض</label>
                            <vs-input class="w-9" v-model="item.width" @keydown.enter.prevent="addOrderInfo()" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label">ارتفاع</label>
                            <vs-input class="w-9" v-model="item.height" @keydown.enter.prevent="addOrderInfo()" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع سیستم</label>
                            <v-select :options="systemsList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.systemType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع اپراتور</label>
                            <v-select :options="operatorsList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.operatorType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label">نوع شیشه (سکوریت)</label>
                            <v-select :options="glassList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.glassType" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع فریم</label>
                            <v-select :options="frameList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.frameType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label input-left">سندبلاست</label>
                            <v-select :options="sandblast" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.sandblast" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label input-left">تعداد</label>
                            <vs-input-number min="1" :value="item.quantity" @input="updateItemQuantity($event, index)" class="item-center input-left" />
                        </vs-col>
                    </vs-row>
                </div>
                <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-col class="sm:w-1/2 w-full">
                        
                    </vs-col>
                    <vs-col class="sm:w-1/2 w-full">
                        <vs-button class="mr-3 float-right" @click="addOrderInfo()" :disabled="!validateForm">ثبت محصول</vs-button>
                        <vs-button class="mr-3 float-right" type="border" @click="addForm()">افزودن محصول</vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'AddOrderProduct',
    props: {
        popupAddOrder: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        // Intersect,
        vSelect,
    },
    
    data() {
		return{
            showPopup: false,
			orders: [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            category: '',
            user_id: '',
            sandblast: [
                {
                    value: 'yes',
                    label: 'دارد'
                },
                {
                    value: 'no',
                    label: 'ندارد'
                }
            ],
		}
    },
    
    computed: {
        validateForm() {
            return this.user_id != '' && this.category != '';
        },

		systemsList() {
            return {
                items: this.$store.state.orders.systems.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
    	},
        operatorsList() {
            return {
                items: this.$store.state.orders.operators.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} (${robot.price} ریال)`,
                    }
                })
            }
    	},
        glassList() {
      		return {
                items: this.$store.state.orders.glass.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
    	},
        frameList() {
      		return {
                items: this.$store.state.orders.frame.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
        },
        categoryList() {
      		return {
                items: this.$store.state.orders.category.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                        admin : `${robot.admin}`
                    }
                })
            }
        },
        usersList() {
            return {
                items: this.$store.state.users.users.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} ${robot.last_name}`,
                    }
                })
            }
		},
    },

    watch: { 
      	popupAddOrder: function(newVal) {
            this.showPopup = newVal
            if(newVal == true) {
                this.$vs.loading()
                this.getUser()
                this.$store.dispatch('getSystemInfo')
                .then(() => {
                    this.$vs.loading.close()
                })
                .catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupAddOrder', newVal)
            this.orders = [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            this.category = ''
            this.user_id = ''
        },
    },

    created(){	
    },
    
    methods: {
        removeRow(i){
            if (i > -1) {
                this.orders.splice(i, 1);
            }
        },

        getUser(){
			this.$store.dispatch('getAllUsers').catch(() => {
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
		},
        
        updateItemQuantity(event, n) {
            this.orders[n].quantity = event
        },

        addForm() {
            let item = {
                width: '',
                height: '',
                quantity: 1,
                systemType: '',
                glassType: '',
                sandblast: '',
            }
            this.orders.push(item)
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        addOrderInfo(){
            this.$vs.loading()
            this.$emit('updatePopupAddOrder', false)
            let message = ''
            this.orders.forEach(order => {
                let width = '-'
                if(order.width){
                    width = order.width
                }
                let height = '-'
                if(order.height){
                    height = order.height
                }
                let type = 'نامشخص'
                if(order.systemType){
                    type = order.systemType.label
                }
                let operator = 'نامشخص'
                if(order.operatorType){
                    operator = order.operatorType.label
                }
                let glass = 'ندارد'
                if(order.glassType){
                    glass = order.glassType.label
                }
                let sandblast = 'ندارد'
                if(order.sandblast){
                    glass = order.sandblast.label
                }
                let frame = 'نامشخص'
                if(order.frameType){
                    frame = order.frameType.label
                }
                let text = `عرض: ${width} \nارتفاع: ${height} \n تعداد: ${order.quantity} \nنوع سیستم: ${type} \nنوع اپراتور: ${operator} \nنوع شیشه: ${glass} \n سندبلاست: ${sandblast} \nنوع فریم: ${frame}`
                message = message + text + '\n'
            });
            this.orders.forEach(order => {
                if(order.systemType){
                    order.systemType = order.systemType.value
                }
                if(order.operatorType){
                    order.operatorType = order.operatorType.value
                }
                if(order.systemType.value != 11) {
                    if(order.glassType){
                        order.glassType = order.glassType.value
                    }
                }
                if(order.frameType){
                    order.frameType = order.frameType.value
                }
                if(order.sandblast){
                    order.sandblast = order.sandblast.value
                }
                else {
                    order.sandblast = 'no'
                }
            });
            let payload = {
                orders: this.orders,
                category: {
                    id: parseInt(this.category.value),
                    name: this.category.label,
                    admin: parseInt(this.category.admin),
                },
                user_id: this.user_id.value,
                type: 'product',
                message: message
            }
            payload = { 
                data: JSON.stringify(payload)
            }
            this.orders = [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            this.category = ''
            this.user_id = ''
			this.$store.dispatch('addOrder', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'سفارش محصول با موفقیت افزوده شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات وارد شده صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        },
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 90% !important;
}

.w-9 {
    width: 98% !important;
}
</style>